webpackJsonp([34471704633725],{

/***/ 136:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Thibault Van Renne — Maintenance"}},"disclaimer":{"html":"<h2>Notice</h2>\n<p>We disapprove the use of any other cleaning products as they can cause\nirreparable and irreversible damage to your TVR rug. If you ran out of\nproducts, you can easily order them here on this website. Should you\nstill not be able to remove your stain from your TVR carpet, please\n<a href=\"https://www.thibaultvanrenne.com/en/contact/\">contact us</a> and we can help with organizing transport, cleaning or\nreparation of your TVR rug.</p>"},"menu_labels":{"strings":{"menu_case":"The Wonder Case","menu_products":"Our products","menu_maintenance":"Maintenance","menu_remove_stains":"Remove your stains","menu_contact_us":"Contact us"}}},"layoutContext":{}}

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _en = __webpack_require__(300);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _layoutEn = __webpack_require__(136);
	
	var _layoutEn2 = _interopRequireDefault(_layoutEn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_en2.default, _extends({}, props, _layoutEn2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@import url(\'https://use.typekit.net/bnx4xdg.css\');\n\n*, *::after, *::before {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  overflow-x: hidden;\n  max-width: 100%;\n  font-size: 13px;\n  ', '\n  ', '\n}\n\nbody {\n  font-family: \'proxima-nova\', sans-serif;\n  line-height: 1.5;\n  color: ', ';\n  width: 100%;\n}\n\n.l-constrained {\n  max-width: 1200px;\n  width: 90%;\n  margin: 0 auto;\n}\n\n.c-body {\n  > * + * {\n    margin-top: ', ';\n  }\n\n  li + li {\n    margin-top: ', ';    \n  }\n}\n'], ['\n@import url(\'https://use.typekit.net/bnx4xdg.css\');\n\n*, *::after, *::before {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  overflow-x: hidden;\n  max-width: 100%;\n  font-size: 13px;\n  ', '\n  ', '\n}\n\nbody {\n  font-family: \'proxima-nova\', sans-serif;\n  line-height: 1.5;\n  color: ', ';\n  width: 100%;\n}\n\n.l-constrained {\n  max-width: 1200px;\n  width: 90%;\n  margin: 0 auto;\n}\n\n.c-body {\n  > * + * {\n    margin-top: ', ';\n  }\n\n  li + li {\n    margin-top: ', ';    \n  }\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 14px;\n  '], ['\n    font-size: 14px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    font-size: 15px;\n  '], ['\n    font-size: 15px;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unstated = __webpack_require__(30);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Menu = __webpack_require__(26);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuToggle = __webpack_require__(27);
	
	var _MenuToggle2 = _interopRequireDefault(_MenuToggle);
	
	var _LanguageSwitcher = __webpack_require__(25);
	
	var _LanguageSwitcher2 = _interopRequireDefault(_LanguageSwitcher);
	
	var _styleUtils = __webpack_require__(3);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Disclaimer = __webpack_require__(23);
	
	var _Disclaimer2 = _interopRequireDefault(_Disclaimer);
	
	__webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	/* eslint no-unused-expressions: off */
	(0, _styledComponents.injectGlobal)(_templateObject, _styleUtils.media.tablet(_templateObject2), _styleUtils.media.desktop(_templateObject3), _styleUtils.colors.black, (0, _styleUtils.rhythm)(1), (0, _styleUtils.rhythm)(1));
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'DefaultLayout__Container'
	})(['position:relative;']);
	
	var StripesContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'DefaultLayout__StripesContainer'
	})(['']);
	var Stripe = _styledComponents2.default.div.withConfig({
	  displayName: 'DefaultLayout__Stripe'
	})(['position:absolute;top:0;height:100%;z-index:-1;border-left:1px solid ', ';&:nth-child(1){left:25%;}&:nth-child(2){left:50%;}&:nth-child(3){left:75%;}'], _styleUtils.colors.mercuryLight);
	
	var DefaultLayout = function (_Component) {
	  _inherits(DefaultLayout, _Component);
	
	  function DefaultLayout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DefaultLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      menuOpen: false
	    }, _this.setMenuOpen = function () {
	      _this.setState({ menuOpen: true });
	    }, _this.setMenuClosed = function () {
	      _this.setState({ menuOpen: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DefaultLayout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data;
	
	    var sitename = data.site.siteMetadata.title;
	    return _react2.default.createElement(
	      _unstated.Provider,
	      null,
	      _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_MenuToggle2.default, { onClick: this.setMenuOpen }),
	        _react2.default.createElement(_LanguageSwitcher2.default, null),
	        _react2.default.createElement(_Menu2.default, {
	          menuLabels: data.menu_labels.strings,
	          isOpen: this.state.menuOpen,
	          onCloseClick: this.setMenuClosed
	        }),
	        _react2.default.createElement(
	          StripesContainer,
	          null,
	          _react2.default.createElement(Stripe, null),
	          _react2.default.createElement(Stripe, null),
	          _react2.default.createElement(Stripe, null)
	        ),
	        children(),
	        _react2.default.createElement(_Footer2.default, { sitename: sitename }),
	        _react2.default.createElement(_Disclaimer2.default, { data: data.disclaimer })
	      )
	    );
	  };
	
	  return DefaultLayout;
	}(_react.Component);
	
	exports.default = DefaultLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'Disclaimer__Wrapper'
	})(['background:', ';color:', ';padding:', ' 1em ', ';'], _styleUtils.colors.black, _styleUtils.colors.white, (0, _styleUtils.rhythm)(2), (0, _styleUtils.rhythm)(2));
	
	var Content = _styledComponents2.default.div.withConfig({
	  displayName: 'Disclaimer__Content'
	})(['font-size:12px;max-width:800px;margin:0 auto;text-align:center;a{color:inherit;}']);
	
	var Disclaimer = function Disclaimer(data) {
	  var html = data.data.html;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(Content, { dangerouslySetInnerHTML: { __html: html } })
	  );
	};
	
	exports.default = Disclaimer;
	module.exports = exports['default'];

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    height: 200px;\n  '], ['\n    height: 200px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    height: 300px;\n  '], ['\n    height: 300px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: auto;\n  '], ['\n    width: auto;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(3);
	
	var _bg = __webpack_require__(48);
	
	var _bg2 = _interopRequireDefault(_bg);
	
	var _miniLogo = __webpack_require__(32);
	
	var _miniLogo2 = _interopRequireDefault(_miniLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FooterWrapper = _styledComponents2.default.footer.withConfig({
	  displayName: 'Footer__FooterWrapper'
	})(['background-image:url(', ');background-size:cover;background-position:center;display:flex;justify-content:center;align-items:center;height:80px;', ';', ';'], _bg2.default, _styleUtils.media.tablet(_templateObject), _styleUtils.media.desktop(_templateObject2));
	
	var FooterImage = _styledComponents2.default.img.withConfig({
	  displayName: 'Footer__FooterImage'
	})(['width:50px;display:block;', ';'], _styleUtils.media.desktop(_templateObject3));
	
	var Footer = function Footer(props) {
	  var sitename = props.sitename;
	
	  return _react2.default.createElement(
	    FooterWrapper,
	    null,
	    _react2.default.createElement(FooterImage, { src: _miniLogo2.default, alt: sitename })
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    top: 10vmin;\n    right: calc(10vmin / 2);\n    margin-right: -1.5em; \n  '], ['\n    top: 10vmin;\n    right: calc(10vmin / 2);\n    margin-right: -1.5em; \n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(46);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styleUtils = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Languages = [{ name: 'EN', prefix: '' }, { name: 'NL', prefix: 'nl' }, { name: 'FR', prefix: 'fr' }, { name: 'RU', prefix: 'ru' }, { name: 'DE', prefix: 'de' }, { name: 'ZH', prefix: 'zh' }];
	
	var Switch = _styledComponents2.default.div.withConfig({
	  displayName: 'LanguageSwitcher__Switch'
	})(['background:black;color:white;display:flex;flex-direction:column;position:fixed;width:3em;text-align:center;z-index:100;top:60px;right:10px;margin-right:0;', ';a{color:inherit;text-decoration:none;font-weight:bold;display:none;background:#e7e7e7;padding:0.5em 0;color:black;}&:hover{a{display:block;}}.is-active{order:-1;display:block;background:black;color:inherit;pointer-events:none;}'], _styleUtils.media.tablet(_templateObject));
	
	var LanguageSwitcher = function (_Component) {
	  _inherits(LanguageSwitcher, _Component);
	
	  function LanguageSwitcher(props) {
	    _classCallCheck(this, LanguageSwitcher);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      loaded: false
	    };
	    return _this;
	  }
	
	  LanguageSwitcher.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({ loaded: true }), 600;
	    });
	  };
	
	  LanguageSwitcher.prototype.render = function render() {
	    var props = this.props;
	    var onClick = props.onClick;
	
	
	    var handleClick = function handleClick(e) {
	      if (e.target.classList.indexOf('is-active')) return false;
	    };
	
	    if (this.state.loaded) {
	      return _react2.default.createElement(
	        Switch,
	        null,
	        Languages.map(function (language) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              key: language.name,
	              exact: true,
	              activeClassName: 'is-active',
	              onClick: handleClick,
	              to: '/' + language.prefix
	            },
	            language.name
	          );
	        })
	      );
	    }
	    return _react2.default.createElement('div', null);
	  };
	
	  return LanguageSwitcher;
	}(_react.Component);
	
	exports.default = LanguageSwitcher;
	module.exports = exports['default'];

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding: 3rem 5rem;\n  '], ['\n    padding: 3rem 5rem;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    width: 75%;\n  '], ['\n    width: 75%;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: 50%;\n  '], ['\n    width: 50%;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['margin: 3em 0;'], ['margin: 3em 0;']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['display: block;'], ['display: block;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(3);
	
	var _miniLogoWhite = __webpack_require__(50);
	
	var _miniLogoWhite2 = _interopRequireDefault(_miniLogoWhite);
	
	var _menuClose = __webpack_require__(49);
	
	var _menuClose2 = _interopRequireDefault(_menuClose);
	
	var _gsap = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Offcanvas = _styledComponents2.default.section.withConfig({
	  displayName: 'Menu__Offcanvas'
	})(['position:fixed;top:0;left:0;width:100%;height:100%;z-index:9999;pointer-events:none;opacity:0;transition:opacity 400ms;transition-delay:400ms;', ';'], function (props) {
	  return props.isOpen && (0, _styledComponents.css)(['transition-delay:0ms;pointer-events:all;opacity:1;.offcanvas__main{transform:translateX(0%);}']);
	});
	
	var OffcanvasSection = _styledComponents2.default.div.withConfig({
	  displayName: 'Menu__OffcanvasSection'
	})(['position:absolute;top:0;height:100%;display:flex;align-items:center;justify-content:space-between;transition:400ms 80ms;transition-timing-function:cubic-bezier(0.01,0.35,0,0.97);width:100%;padding:3rem 1rem;', ';', ';', ';', ';', ';'], _styleUtils.media.tablet(_templateObject), _styleUtils.media.tablet(_templateObject2), _styleUtils.media.desktop(_templateObject3), function (props) {
	  return props.main && (0, _styledComponents.css)(['background:', ';transform:translateX(100%);right:0;'], _styleUtils.colors.black);
	}, function (props) {
	  return props.side && (0, _styledComponents.css)(['&&{width:100%;}left:0;opacity:0.8;background:', ';'], _styleUtils.colors.white);
	});
	var OffcanvasMenu = _styledComponents2.default.nav.withConfig({
	  displayName: 'Menu__OffcanvasMenu'
	})(['overflow:hidden;color:', ';font-weight:300;font-size:18px;letter-spacing:0.08em;line-height:1.2;-webkit-font-smoothing:antialiased;text-transform:uppercase;li{display:block;margin:1em 0;', ';}a{color:inherit;text-decoration:inherit;}'], _styleUtils.colors.white, _styleUtils.media.tablet(_templateObject4));
	
	var MenuIndex = _styledComponents2.default.span.withConfig({
	  displayName: 'Menu__MenuIndex'
	})(['display:block;']);
	var MenuLabel = _styledComponents2.default.span.withConfig({
	  displayName: 'Menu__MenuLabel'
	})(['font-weight:bold;', ';'], _styleUtils.media.tablet(_templateObject5));
	
	var MenuClose = _styledComponents2.default.button.withConfig({
	  displayName: 'Menu__MenuClose'
	})(['position:absolute;z-index:500;right:20px;top:20px;background:none;appearance:none;border:0;border-radius:0;cursor:pointer;&:focus{outline:none;}']);
	
	var Logo = _styledComponents2.default.img.withConfig({
	  displayName: 'Menu__Logo'
	})(['display:none;', ';'], _styleUtils.media.tablet(_templateObject5));
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Menu.prototype.handleMenuItemClick = function handleMenuItemClick(e) {
	    e.preventDefault();
	    var anchor = '#' + e.currentTarget.href.split('#').pop();
	    this.props.onCloseClick();
	    _gsap.TweenMax.to(window, 1, { scrollTo: anchor, ease: _gsap.Strong.easeInOut });
	  };
	
	  Menu.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        isOpen = _props.isOpen,
	        onCloseClick = _props.onCloseClick,
	        menuLabels = _props.menuLabels;
	
	    console.log(menuLabels);
	    var menuItems = [{ name: menuLabels.menu_case, href: '#about' }, { name: menuLabels.menu_products, href: '#products' }, { name: menuLabels.menu_maintenance, href: '#maintenance' }, { name: menuLabels.menu_remove_stains, href: '#filter' }, { name: menuLabels.menu_contact_us, href: '#contact' }];
	    return _react2.default.createElement(
	      Offcanvas,
	      { className: 'offcanvas', isOpen: isOpen },
	      _react2.default.createElement(
	        MenuClose,
	        { onClick: onCloseClick },
	        _react2.default.createElement('img', { src: _menuClose2.default, alt: 'Close menu' })
	      ),
	      _react2.default.createElement(OffcanvasSection, { side: 'true', className: 'side' }),
	      _react2.default.createElement(
	        OffcanvasSection,
	        { className: 'offcanvas__main', main: 'true' },
	        _react2.default.createElement(Logo, { src: _miniLogoWhite2.default, alt: 'Thibault Van Renne' }),
	        _react2.default.createElement(
	          OffcanvasMenu,
	          null,
	          _react2.default.createElement(
	            'ul',
	            null,
	            menuItems.map(function (item, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: item.name },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    onClick: _this2.handleMenuItemClick.bind(_this2),
	                    href: item.href
	                  },
	                  _react2.default.createElement(
	                    MenuIndex,
	                    null,
	                    '0',
	                    index + 1,
	                    '\u2014'
	                  ),
	                  _react2.default.createElement(
	                    MenuLabel,
	                    null,
	                    item.name.split(' ').map(function (word) {
	                      return _react2.default.createElement(
	                        MenuLabel,
	                        { key: item.href + word },
	                        word,
	                        ' '
	                      );
	                    })
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 80px;\n    height: 80px;\n    top: calc(', ' / 2 - 40px);\n    right: calc(', ' / 2 - 40px);\n  '], ['\n    width: 80px;\n    height: 80px;\n    top: calc(', ' / 2 - 40px);\n    right: calc(', ' / 2 - 40px);\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _menuOpen = __webpack_require__(31);
	
	var _menuOpen2 = _interopRequireDefault(_menuOpen);
	
	var _styleUtils = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Button = _styledComponents2.default.button.withConfig({
	  displayName: 'MenuToggle__Button'
	})(['border:0;border-radius:0;background:none;position:fixed;cursor:pointer;z-index:99;display:flex;align-items:center;justify-content:center;top:0;right:0;width:60px;height:60px;', ';&:focus{outline:none;}img{display:block;flex-grow:0;flex-shrink:0;}'], _styleUtils.media.tablet(_templateObject, _styleUtils.introGutter, _styleUtils.introGutter));
	
	var MenuToggle = function MenuToggle(props) {
	  var onClick = props.onClick;
	
	  return _react2.default.createElement(
	    Button,
	    { onClick: onClick },
	    _react2.default.createElement('img', { src: _menuOpen2.default, alt: 'Open menu' })
	  );
	};
	
	exports.default = MenuToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDM2IDI2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSkiPgogICAgPHBhdGggZD0iTS40MjUgMTIuNUwzMy42MTg1NjExIDEyLjVNLjQyNS41TDMzLjYxODU2MTEuNU0uNDI1IDI1LjVMMzMuNjE4NTYxMSAyNS41Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MiIgaGVpZ2h0PSIzOCIgdmlld0JveD0iMCAwIDkyIDM4Ij4KICA8ZyBmaWxsPSIjMUQxRDFCIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTY0LjYxODcwMjcsNC4xMjAxNDUzMiBDNjQuNjE4NzAyNywyLjQwNzY2MzcgNjMuNTk5NjA0OSwxLjAxNTY1NjA5IDYxLjY3MDA2OTEsMC4xMDY4MjQ2NjkgTDYxLjY3MDA2OTEsMCBMNzEsMCBMNzEsMC4xMDY4MjQ2NjkgQzY5LjAxNjEzNDMsMS4zOTAzNjQxNiA2Ny41NjczMzYyLDMuMjYzOTA0NTEgNjYuMDEzMTcwOSw2LjU4MzY4NjUzIEw1MS4yNjgzNTY5LDM4IEw1MS4wNTI2ODM2LDM4IEwzNS4zOTc0MzE3LDUuOTkzNjg1NjcgQzMzLjc4ODkzNjUsMi42NzU1NDcxIDMyLjkzMTE4MjEsMS4zOTAzNjQxNiAzMSwwLjEwNjgyNDY2OSBMMzEsMCBMNDcuNzI4Njc5NiwwIEw0Ny43Mjg2Nzk2LDAuMTA2ODI0NjY5IEM0Ni4xNzQ1MTQzLDEuMDE1NjU2MDkgNDUuNDc2NDU3LDEuODcxODk2ODkgNDUuNDc2NDU3LDMuMTAyODQ1NzcgQzQ1LjQ3NjQ1Nyw0LjEyMDE0NTMyIDQ1Ljc0NDgxNCw1LjAzMDYyMDE5IDQ2LjI4MTUyNzgsNi4xNTQ3NDQ0IEw1NS40NTAxMTUyLDI1LjYzNjI3NzEgTDYzLjkyMjI5MTcsNy4wMTA5ODUyMSBDNjQuMzUwMzQ1Nyw2LjA0NjI3NjI3IDY0LjYxODcwMjcsNS4wODMyMTA3OSA2NC42MTg3MDI3LDQuMTIwMTQ1MzIiLz4KICAgIDxwYXRoIGQ9Ik04Ni40NTc5NjQ3IDMxLjIxNDEwNzFMODUuMDMwNzUxNiAyNi45ODAyMTY3QzgzLjQ5NDAxMjIgMjIuNDE5NjE2NiA4MC40MjIyMTgyIDIwLjI0OTMzMTEgNzQuNTQ5OTE4OCAxOS45MjI2MjE0IDgxLjA3OTM3NjUgMTkuODY5MjgxIDg3LjE3MDcyODggMTYuNjEyMTg1OCA4Ny4xNzA3Mjg4IDEwLjIwNDY3NjEgODcuMTcwNzI4OCAyLjg3NzA0NTIzIDgxLjA3OTM3NjUgMCA3Mi44NDgwNDcyIDBMNjQuMzYzOTY0NiAwIDY0LjM2Mzk2NDYgMS40NjUxOTI3OSA2OC4zNDkwNDAxIDEuNDY1MTkyNzlDNzMuNjE2NDE2OSAxLjQ2NTE5Mjc5IDc2LjMwNTcxMSA0Ljg4NTY0Mjg1IDc2LjMwNTcxMSAxMC4yNTk2ODMzIDc2LjMwNTcxMSAxNS43NDM3MzgyIDczLjM5NzM2NDEgMTguOTQ1ODI2MiA2OC4zNDkwNDAxIDE4Ljk0NTgyNjJMNjQuNjg1ODAzNyAxOC45NDU4MjYyIDY0IDIwLjQxMTAxOSA2Ny40NzExNDQgMjAuNDExMDE5QzcxLjQ3NjQzOTggMjAuNDExMDE5IDcyLjg0ODA0NzIgMjIuNTI3OTY0MiA3My43ODE1NDkgMjUuNTEzMzU3TDc1LjY0Njg2NzcgMzIuMTM3NTYyQzc2LjM2MTMxNjcgMzQuNTc5NTQ5OSA3Ny4xODM2MDcxIDM2LjUzNDgwNzIgNzguNDQ1Njg4MiAzOEw5MiAzOCA5MiAzNy44OTE2NTI0Qzg4Ljg3MjYwMDMgMzYuMzE2NDQ1MSA4Ny42NjQ0NCAzNC45MDYyNTk2IDg2LjQ1Nzk2NDcgMzEuMjE0MTA3MU0yOS4zNjE1MzQ1IDMxLjYyMTQxMDlMMjkuMzYxNTM0NSAxLjg3NjA1NTYxIDM1IDEuODc2MDU1NjEgMzUgLjQ4MjE3OTIwNCA1LjQ5MjUxNzI2LjQ4MjE3OTIwNEMzLjY5NzM1NDQuNDgyMTc5MjA0IDIuNTM0NjMzNzQuMzc1MjExMTIxIDEuNzk1MTYyODYgMEwwIDEyLjcwMjg3MTIuMTA1NDA3MDMzIDEyLjcwMjg3MTJDNC41OTU3NDY2NSA1LjQxMjU4NDk5IDYuNjU1MjM3OTIgMS44NzYwNTU2MSAxMi4zMDUwNTQ5IDEuODc2MDU1NjFMMTkuNDMyMTkyIDEuODc2MDU1NjEgMTkuNDMyMTkyIDMxLjYyMTQxMDlDMTkuNDMyMTkyIDM1LjE1OTU4NiAxOC43OTk3NDk4IDM2LjMzNzg4MDYgMTYuNDIyNDE1OCAzNy44OTEzODYzTDE2LjQyMjQxNTggMzggMzIuMzcxMzEwOCAzOCAzMi4zNzEzMTA4IDM3Ljg5MTM4NjNDMzAuMDQ3NDkxMSAzNi4zMzc4ODA2IDI5LjM2MTUzNDUgMzUuMTU5NTg2IDI5LjM2MTUzNDUgMzEuNjIxNDEwOSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.layoutQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DefaultLayout = __webpack_require__(22);
	
	var _DefaultLayout2 = _interopRequireDefault(_DefaultLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Template = function Template(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	
	  return _react2.default.createElement(_DefaultLayout2.default, { data: data, children: children });
	};
	
	exports.default = Template;
	
	/* eslint no-undef: off */
	
	var layoutQuery = exports.layoutQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-en-js-a1d1cdc2d98636991bd0.js